var React = require('react');

function IconMinusBase16x16 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":".Minus Base"},React.createElement("path",{"id":"Path","d":"M14.6666 8H1.33325","stroke":"#142B6F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"})));
}

IconMinusBase16x16.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IconMinusBase16x16;

IconMinusBase16x16.default = IconMinusBase16x16;
